import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { icon, latLngBounds, marker, tileLayer } from 'leaflet';
import { debounceTime } from 'rxjs/operators';
import { ConfirmDialogService } from '../../../../@fuse/components/confirm-dialog/confirm-dialog.service';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { QueryCoordinatesGeocodeGQL } from '../../../main/locations/services/location.service';
import { normalizeAddress } from '../../utils/normalize-Address';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var MapAddressComponent = /** @class */ (function () {
    function MapAddressComponent(translate, queryCoordinatesGeocodeGQL, fuseTranslationLoaderService, confirmDialogService, translateService) {
        this.translate = translate;
        this.queryCoordinatesGeocodeGQL = queryCoordinatesGeocodeGQL;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.confirmDialogService = confirmDialogService;
        this.translateService = translateService;
        this.markerClusterData = [];
        this.options = {
            zoom: 5,
            minZoom: 2,
            fullscreenControl: true,
            layers: [
                tileLayer('https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7')
            ]
        };
        this.layersControl = {
            baseLayers: {}
        };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    MapAddressComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addLayer('DEFAULT', 'https://mt0.google.com/vt/lyrs=m&hl=pt&x={x}&y={y}&z={z}&s=Ga7');
        this.addLayer('SATELLITE', 'https://mt0.google.com/vt/lyrs=y&hl=pt&x={x}&y={y}&z={z}&s=Ga7');
        this.addLayer('TERRAIN', 'https://mt0.google.com/vt/lyrs=p&hl=pt&x={x}&y={y}&z={z}&s=Ga7');
        var coords = this.addressForm.get('coords').value;
        if (coords && coords.latitude && coords.longitude) {
            this.createMarker({
                lat: coords.latitude,
                lng: coords.longitude
            });
        }
        else {
            this.fitBoundsOptions = latLngBounds([-47.186656, -98.472544], [5.664193, -28.775281]);
        }
        this.addressForm.valueChanges
            .pipe(debounceTime(1000))
            .subscribe(function (value) {
            if (value.coords.latitude && value.coords.longitude) {
                _this.markerClusterData = [];
                _this.createMarker({
                    lat: value.coords.latitude,
                    lng: value.coords.longitude
                });
            }
        });
    };
    MapAddressComponent.prototype.createMarker = function (_a) {
        var _this = this;
        var lat = _a.lat, lng = _a.lng;
        if (this.markerClusterData.length) {
            return;
        }
        this.fitBoundsOptions = latLngBounds([[lat, lng]]);
        var pointer = marker([lat, lng], {
            draggable: !this.isViewMode,
            icon: icon({
                iconUrl: 'assets/images/icons/ic_location_marker_32px.svg',
                iconSize: [32, 36],
                iconAnchor: [16, 36],
                popupAnchor: [0, -36]
            })
        });
        this.markerClusterData = [pointer];
        if (this.addressForm.get('formattedAddress').value) {
            pointer.bindPopup(this.addressForm.get('formattedAddress').value);
        }
        pointer.on('dragend', function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var coords;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        coords = event.target.getLatLng();
                        return [4 /*yield*/, this.queryCoordinatesGeocodeGQL.fetch({ input: { latitude: coords.lat, longitude: coords.lng } })
                                .toPromise()
                                .then(function (result) { return result.data && result.data['coordinatesGeocode']; })
                                .then(normalizeAddress)
                                .then(function (address) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var result;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!address) {
                                                return [2 /*return*/];
                                            }
                                            address.coords = { latitude: coords.lat, longitude: coords.lng };
                                            this.addressForm.get('coords').setValue(address.coords, { emitEvent: false });
                                            return [4 /*yield*/, this.confirmDialogService.open({
                                                    title: this.translateService.instant('CONFIRM_CHANGE_ADDRESS.TITLE'),
                                                    message: this.translateService.instant('CONFIRM_CHANGE_ADDRESS.MESSAGE', {
                                                        previousAddress: this.addressForm.get('formattedAddress').value || this.translateService.instant('CONFIRM_CHANGE_ADDRESS.NO_ADDRESS'),
                                                        newAddress: address.formattedAddress
                                                    }),
                                                    okText: this.translateService.instant('CONFIRM_CHANGE_ADDRESS.YES'),
                                                    cancelText: this.translateService.instant('CONFIRM_CHANGE_ADDRESS.NO'),
                                                })];
                                        case 1:
                                            result = _a.sent();
                                            if (!result || !result.confirmed) {
                                                return [2 /*return*/];
                                            }
                                            address.postalCode = address.postalCode && address.postalCode.replace(/[^0-9]/g, '');
                                            this.addressForm.setValue(address, { emitEvent: false });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    MapAddressComponent.prototype.addLayer = function (name, layerUrl) {
        var translatedName = this.translate.instant("LOCATIONS.DIALOG.TABS.TAB_LOCATION.MAPS." + name);
        this.layersControl.baseLayers[translatedName] = tileLayer(layerUrl);
    };
    return MapAddressComponent;
}());
export { MapAddressComponent };
